import axios, { AxiosInstance, AxiosResponse } from "axios";
import { UserPastTicketResponse } from "../../../@Types/DRO/ChurnApiResponse/UserPastTicketsResponse";



export class GetUserPastTicketsApi {
    public static api = new GetUserPastTicketsApi();
    private instance: AxiosInstance;

    constructor() {
        this.instance = axios.create({
            baseURL: process.env.REACT_APP_CHURN_BASE_URL,
            headers: {
                "Content-Type": "application/json",
            },
        });
    }

    getToken() {
        return localStorage.getItem("token");
    }

    async getUserPastTickets(user_id: number): Promise<UserPastTicketResponse> {
        try {
            const response: AxiosResponse<UserPastTicketResponse> = await this.instance.get(`/user-past-tickets/`, {
                headers: {
                    Authorization: `Bearer ${this.getToken()}`,
                },
                params: {
                    user_id,
                },
            });
            return response.data;
        } catch (error) {
            console.error("Error fetching user past tickets", error);
            throw error;
        }
    }
}